
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/saas",
      function () {
        return require("private-next-pages/solutions/saas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/saas"])
      });
    }
  